import React, { ChangeEvent, Component, useState } from "react";
import "./OrderOnHoldModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";

type Props = {
    closeModalFn: () => void;
    onHoldFn: (onHoldReason: string, sendEmail: boolean) => void;
};

export const OrderOnHoldModal: React.FC<Props> = (props) => {
    const [onHoldReason, setOnHoldReason] = useState("");
    const [sendEmail, setSendEmail] = useState(false);

    const closeModal = () => {
        props.closeModalFn();
    };

    const submitOnHold = () => {
        props.onHoldFn(onHoldReason, sendEmail);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "on_hold_reason":
                setOnHoldReason(value);
                break;

            case "send_email":
                setSendEmail(value);
                break;
        }
    };

    return (
        <div className={"OrderOnHoldModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-pause"} title={"hold_order"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"on_hold_reason"} />
                    <OwTextArea fn={handleChange} name={"on_hold_reason"} value={onHoldReason} />
                </div>

                <div className={"mt-4"}>
                    <OwCheckbox
                        name={"send_email"}
                        fn={handleChange}
                        checked={sendEmail}
                        truthyVal={true}
                        falsyVal={false}
                        label={"send_email"}
                    />
                </div>
            </div>

            <div className={"mt-4"}>
                <OwButton title={"submit"} fn={submitOnHold} />
            </div>
        </div>
    );
};
